/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Document_Title_PlaceholderInputs */

const en_ccsl_export_document_title_placeholder = /** @type {(inputs: Ccsl_Export_Document_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document Title`)
};

const fr_ccsl_export_document_title_placeholder = /** @type {(inputs: Ccsl_Export_Document_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre du document`)
};

const de_ccsl_export_document_title_placeholder = /** @type {(inputs: Ccsl_Export_Document_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumenttitel`)
};

const it_ccsl_export_document_title_placeholder = /** @type {(inputs: Ccsl_Export_Document_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo del documento`)
};

const ru_ccsl_export_document_title_placeholder = /** @type {(inputs: Ccsl_Export_Document_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название документа`)
};

const es_ccsl_export_document_title_placeholder = /** @type {(inputs: Ccsl_Export_Document_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título del documento`)
};

const zh_cn2_ccsl_export_document_title_placeholder = /** @type {(inputs: Ccsl_Export_Document_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件标题`)
};

const ja_ccsl_export_document_title_placeholder = /** @type {(inputs: Ccsl_Export_Document_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書タイトル`)
};

const hi_ccsl_export_document_title_placeholder = /** @type {(inputs: Ccsl_Export_Document_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दस्तावेज़ का शीर्षक`)
};

const pt_pt2_ccsl_export_document_title_placeholder = /** @type {(inputs: Ccsl_Export_Document_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título do documento`)
};

/**
* | output |
* | --- |
* | "Document Title" |
*
* @param {Ccsl_Export_Document_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_document_title_placeholder = /** @type {((inputs?: Ccsl_Export_Document_Title_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Document_Title_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_document_title_placeholder(inputs)
	if (locale === "de") return de_ccsl_export_document_title_placeholder(inputs)
	if (locale === "it") return it_ccsl_export_document_title_placeholder(inputs)
	if (locale === "ru") return ru_ccsl_export_document_title_placeholder(inputs)
	if (locale === "es") return es_ccsl_export_document_title_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_document_title_placeholder(inputs)
	if (locale === "ja") return ja_ccsl_export_document_title_placeholder(inputs)
	if (locale === "hi") return hi_ccsl_export_document_title_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_document_title_placeholder(inputs)
	return en_ccsl_export_document_title_placeholder(inputs)
});